export default {
  // 获取摄像头列表
  getCameraList: {
    method: 'get',
    url: '/api/getCameraList',
    errorMessage: false
  },
  getCameraListNoLogin: {
    method: 'get',
    url: '/api/getCameraListNoLogin',
    errorMessage: false
  },
  // 获取摄像头详情
  getCameraDetails: {
    method: 'get',
    url: '/api/getCameraDetails',
    errorMessage: false
  },
  getCameraDetailsNoLogin: {
    method: 'get',
    url: '/api/getCameraDetailsNoLogin',
    errorMessage: false
  },
  // 获取设备列表
  getIotDevice: {
    method: 'get',
    url: '/api/getIotDevice',
    errorMessage: false
  },
  getIotDeviceNoLogin: {
    method: 'get',
    url: '/api/getIotDeviceNoLogin',
    errorMessage: false
  },
  // 获取设备实时数据
  getDeviceData: {
    method: 'get',
    url: '/api/getDeviceData',
    errorMessage: false
  },
  getDeviceDataNoLogin: {
    method: 'get',
    url: '/api/getDeviceDataNoLogin',
    errorMessage: false
  },
  // 获取产品属性
  getProperties: {
    method: 'get',
    url: '/api/getProperties',
    errorMessage: false
  },
  getIotDevgetDeviceDataNoLoginiceNoLogin: { // 不登陆获取设备实时数据
    url: '/api/getDeviceDataNoLogin',
    method: 'get',
    errorMessage: false
  },
  getDeviceDataNoGroup: { // 获取所有感器数据
    url: '/api/getDeviceDataNoGroup',
    method: 'get',
    errorMessage: false
  },
  getDataHistory: { // 获取传感器历史记录
    url: '/api/getDataHistory',
    method: 'get',
    errorMessage: false
  },
  // 获取传感器预警详情
  getWarningMsgByIdentifier: {
    method: 'get',
    url: '/api/getWarningMsgByIdentifier'
  }
}
